var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M26.5 14.866C27.1667 14.4811 27.1667 13.5189 26.5 13.134L8.5 2.74167C7.83333 2.35677 7 2.8379 7 3.6077L7 24.3923C7 25.1621 7.83333 25.6432 8.5 25.2583L26.5 14.866Z",
    fill: "#7CCEE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.05c2b9371f08d4480a5a534c29738553.svg";
export { ForwardRef as ReactComponent };